import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Dumbo from '../../Dumbo';
import FooterPanel, { FOOTER_PANEL_HEIGHT } from '../../Helper/FooterPanel';
import StackOverlay from './_partials/StackOverlay';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import s from './Stack.scss';
var STACK_INDICATOR_HEIGHT = parseInt(s['stack-indicator-height']);
var Stack = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, url = _a.url, style = _a.style, biData = _a.biData, onClick = _a.onClick;
    var dumboHeight = height
        ? height - (FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT)
        : undefined;
    var linkAsWrapper = [
        DeviationTypes.IMAGE,
        DeviationTypes.FILM,
        DeviationTypes.PDF,
    ].includes(getDeviationType(deviation));
    var content = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['stack-indicator'] },
            React.createElement("div", { className: s['stack-indicator-inner'] })),
        React.createElement("div", { className: s['content-wrapper'] },
            React.createElement("div", { className: s['content'] },
                React.createElement(Dumbo, { deviation: deviation, width: width, height: dumboHeight }),
                React.createElement(StackOverlay, { width: width, height: dumboHeight, url: linkAsWrapper ? undefined : url, onClick: linkAsWrapper ? undefined : onClick, className: s['overlay'] })),
            React.createElement(FooterPanel, { deviation: deviation, withAuthorLink: false }))));
    if (linkAsWrapper) {
        return (React.createElement(PlainButtonOrLink, { className: classnames(s['root'], deviation.hasNewContent && s['unread'], className), href: url, onClick: onClick, biData: biData, style: __assign(__assign({}, style), { width: width,
                height: height }) }, content));
    }
    return (React.createElement("div", { className: classnames(s['root'], deviation.hasNewContent && s['unread'], className), style: __assign(__assign({}, style), { width: width, height: height }) },
        content,
        React.createElement(PlainButtonOrLink, { href: url, onClick: onClick, className: s['link-overlay'], biData: biData })));
};
Stack.displayName = 'StackThumb';
export default Stack;
export var SIZE_ADJUSTMENTS = FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT;
//# sourceMappingURL=Stack.js.map